import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { REQUEST_LOADING_STATES } from "../../helpers/constant";
import { ICommonState } from "../../helpers/types";
import { userService } from "../../services";

const initialState: ICommonState = {
  countries: [],
  total: 0,
  loading: REQUEST_LOADING_STATES.IDLE,
  error: null,
};

export const getCountries = createAsyncThunk("users/getCountries", async () => {
  return userService.getVatCountries();
});

const CommonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCountries.pending, (state) => {
      state.loading = REQUEST_LOADING_STATES.PENDING;
      state.error = null;
    });
    builder.addCase(getCountries.fulfilled, (state, action) => {
      state.countries = action.payload.list;
      state.total = action.payload.total;
      state.loading = REQUEST_LOADING_STATES.SUCCEEDED;
    });
    builder.addCase(getCountries.rejected, (state, action) => {
      state.loading = REQUEST_LOADING_STATES.FAILED;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default CommonSlice.reducer;
